import { render, staticRenderFns } from "./StaticResidentialProxy.vue?vue&type=template&id=1c0518f3&scoped=true"
import script from "./StaticResidentialProxy.vue?vue&type=script&lang=js"
export * from "./StaticResidentialProxy.vue?vue&type=script&lang=js"
import style0 from "./StaticResidentialProxy.vue?vue&type=style&index=0&id=1c0518f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0518f3",
  null
  
)

export default component.exports